import * as fromActions from '../actions/questionsTypes.action'
import { IQuestionTypes } from 'models/questionTypes.model'

import { Reducer } from 'redux'

export const initialState: IQuestionTypes = {
  types: [],
}

export const reducer: Reducer<IQuestionTypes> = (state: IQuestionTypes = initialState, { type, payload }) => {
  switch (type) {
    case fromActions.GET_QUESTION_TYPES_LIST_SUCCESS:
      return {
        ...state,
        types: payload,
      }
    default:
      return state
  }
}
